import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { useSeo } from "../../lib/seo";
import { localApi } from "../../lib/localApi";
import { TopBar, Hero, ProofStrip, Features, Channels, Steps, Testimonials, FinalCTA, Footer, Faq, LANDING_FAQ } from "./LandingSections";
import { Results, ProductShot, Migration } from "./LandingResults";
import { FaqJsonLd } from "../SeoGuide";
import { Pricing } from "./LandingPricing";
import { IncludedTable } from "./LandingIncluded";
import { DemoForm } from "./LandingDemoForm";
import { MobileApp } from "./LandingMobile";
import { SupportChatBubble } from "../../components/SupportChatBubble";

export default function Landing() {
  const [params] = useSearchParams();
  useSeo({
    title: "Casanéo · Logiciel de conciergerie et gestion locative courte durée",
    description: "Synchro Airbnb, Booking, Vrbo, Expedia, Google et 100+ canaux via Channex, paiements Stripe, cautions Stripe ou LivretAccueil, relevés propriétaires dans leur espace, espace ménage. Construit par une conciergerie, pour les conciergeries. 14 jours gratuits.",
    path: "/",
  });
  useEffect(() => {
    const ref = params.get("ref");
    if (ref) localStorage.setItem("cn_ref", ref.toUpperCase());
  }, [params]);
  const { data } = useQuery({ queryKey: ["public-landing"], queryFn: async () => (await localApi.get("/public/landing")).data, staleTime: 600_000, retry: 1 });

  return (
    <div className="landing typo-a min-h-screen bg-[#071e42] text-slate-100 selection:bg-brass/40 selection:text-white" data-testid="landing-page">
      <div className="pointer-events-none fixed inset-0 opacity-70">
        <div className="absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-brass/10 blur-[120px]" />
        <div className="absolute top-1/3 -right-40 h-[620px] w-[620px] rounded-full bg-sky-500/10 blur-[140px]" />
        <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize: "32px 32px" }} />
      </div>
      <div className="relative">
        <TopBar />
        <Hero trialDays={data?.trial_days || 14} offer={data?.launch_offer} />
        <Results />
        <ProductShot />
        <Features />
        <Channels />
        <MobileApp />
        <ProofStrip proof={data?.proof} />
        <Testimonials proof={data?.proof} ownerReviews={data?.owner_reviews || []} testimonials={data?.testimonials || []} />
        <Pricing plans={data?.plans} trialDays={data?.trial_days || 14} offer={data?.launch_offer} />
        <IncludedTable />
        <Migration />
        <Steps />
        <DemoForm />
        <FinalCTA />
        <Faq />
        <FaqJsonLd faq={LANDING_FAQ} id="landing-faq-jsonld" />
        <Footer />
        <SupportChatBubble />
        <a href="/onboarding" className="md:hidden fixed bottom-4 left-4 right-4 z-40 rounded-full bg-brass text-[#0b1a35] font-semibold text-center py-3.5 shadow-xl shadow-black/40" data-testid="landing-sticky-cta">Essayer 14 jours gratuits</a>
      </div>
    </div>
  );
}
